<template>
    <div>
        <!--查出报考指南-->
            <div  class="item introduction">
                <div style="min-height: 125px;" class="main position-relative">
                    <div  class="con" v-show="bkznData!==''&&!loadingDetail">
                        <div  class="info">
                            <div  class="sonTitle font-weight-bolder text-m-size">专业前景</div>
                            <div style="min-height: 200px;" v-show="bkznData.occupationalDirection!==null"
                                 class="introduction text-default-color"
                                 v-html="bkznData.occupationalDirection">
                            </div>
                            <empty content="暂无专业前景相关内容" v-show="bkznData.occupationalDirection===null"></empty>
                        </div>
                       <div  class="info">
                           <div  class="sonTitle font-weight-bolder text-m-size">专业生源信息</div>

                            <div style="min-height:300px;" >
                                <div class="rowPl">
                                    <h6>
                                        全国普通高校毕业生规模
                                    </h6>
                                    <div class="count">
                                        <span>{{bkznData.graduates}}</span>
                                    </div>
                                </div>
                                <div class="rowPl">
                                    <div id="wlk"  class="charts" style="width: 330px ;height: 230px;">
                                    </div>
                                </div>
                                <div class="rowPl">
                                    <div id="nvBl" class="charts" style="width: 330px;height: 230px;">
                                    </div>
                                </div>
                            </div>
                            <empty content="暂无专业前景相关内容" v-show="bkznData.occupationalDirection===null"></empty>
                        </div>
                        <div  class="info">
                            <div  class="sonTitle font-weight-bolder text-m-size">报考建议</div>
                            <div style="min-height:200px;" v-show="bkznData.examAdvise!==''"
                                 class="introduction text-default-color"
                                 v-html="bkznData.examAdvise">
                            </div>
                            <empty content="暂无报考建议相关内容" :text-size="18" v-show="bkznData.examAdvise===''"></empty>
                        </div>
                        <div  class="info  ">
                            <div  class="sonTitle font-weight-bolder text-m-size">未来就业建议</div>
                            <div style="min-height: 200px;" v-show="bkznData.employment!==''"
                                 class="introduction text-default-color"
                                 v-html="bkznData.occupationalDirection">
                            </div>
                            <empty content="暂无就业建议相关内容" :text-size="18" v-show="bkznData.employment===''"></empty>
                        </div>
                    </div>
                </div>
            </div>

    </div>
</template>

<script>
    import {EventBus} from "../../../../assets/static/global/event-bus";
    import {professionExamGuide} from "../../../../config";

    export default {
        name: "professionBkZn",
        props:{
          professionId:String
        },
        data(){
            return{
                bkznData:'',
                loadingDetail:false,

                wlkDataFirst:[],
                sexDataList:[],
            }
        },
        mounted() {
            EventBus.$on('professionBkZn',(()=>{
                this.searchProfessionBkzn();
            }))
        },
        beforeDestroy(){
            EventBus.$off('professionBkZn');
        },
        methods:{
            //查出专业数据内容
            async searchProfessionBkzn(){
                this.loadingDetail=true;
                let result=await professionExamGuide(this.professionId);
                if(result.status){
                    this.loadingDetail=false;
                    this.bkznData=result.data;
                    this.wlkDataFirst=[];
                    JSON.parse(result.data.wlRatio).list.forEach((val)=>{
                        this.wlkDataFirst.push(val.name)
                    })
                    JSON.parse(result.data.sexRatio).list.forEach((val)=>{
                        this.sexDataList.push(val.name);
                    })
                    console.log(result.data);
                    this.wlkSxImg();
                    this.nGBl();
                }else{
                    this.loadingDetail=false;
                }
            },
            //查出文理科扇形图
            wlkSxImg(){
               let myCharts=this.$echarts.init(document.getElementById('wlk'));
               myCharts.setOption({
                   title: {
                       text:JSON.parse(this.bkznData.wlRatio).title,
                       left: 'center',
                       textStyle: {
                           color: '#333333',
                           fontWeight: 'bold',
                           fontSize: 15
                       }
                   },
                   tooltip: {
                       trigger: 'item',
                       formatter: '{a} <br/>{b}: {c} ({d}%)'
                   },
                   legend: {
                       orient: 'vertical',
                       left: 10,
                       data: this.wlkDataFirst
                   },
                   series: [
                       {
                           name:JSON.parse(this.bkznData.wlRatio).title,
                           type: 'pie',
                           radius: ["35%", "45%"], // 这个属性修改圆环宽度
                           emphasis: {
                               itemStyle: {
                                   shadowBlur: 10,
                                   shadowOffsetX: 0,
                                   shadowColor: 'rgba(0, 0, 0, 0.5)'
                               }
                           },
                           data:  JSON.parse(this.bkznData.wlRatio).list
                       }
                   ]
               })
            },
            //查出男女比例扇形图
            nGBl(){
                let myCharts=this.$echarts.init(document.getElementById('nvBl'));
                myCharts.setOption({
                    title: {
                        text:JSON.parse(this.bkznData.sexRatio).title,
                        left: 'center',
                        textStyle: {
                            color: '#333333',
                            fontWeight: 'bold',
                            fontSize: 15
                        }
                    },
                    tooltip: {
                        trigger: 'item',
                        formatter: '{a} <br/>{b}: {c} ({d}%)'
                    },
                    legend: {
                        orient: 'vertical',
                        left: 10,
                        data:this.sexDataList
                    },
                    series: [
                        {
                            name:JSON.parse(this.bkznData.sexRatio).title,
                            type: 'pie',
                            radius: ["35%", "45%"], // 这个属性修改圆环宽度
                            emphasis: {
                                itemStyle: {
                                    shadowBlur: 10,
                                    shadowOffsetX: 0,
                                    shadowColor: 'rgba(0, 0, 0, 0.5)'
                                }
                            },
                            data:  JSON.parse(this.bkznData.sexRatio).list
                        }
                    ]
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
    .con{
        .info{
            .rowPl{
                text-align: center;
                width: 33.33%;
                float: left;
                height: 260px;
                border-right: 1px solid #eee;
                -webkit-box-sizing: border-box;
                box-sizing: border-box;
                h6{
                    font-size: 14px;
                    color: #555;
                    font-weight: 400;
                    padding: 20px 0 45px;
                }
                .count{
                    background: url(https://s.diyigaokao.com/v4/sprite/201902271053.jpg) no-repeat 50%;
                    font-size: 16px;
                    color: #fcb65b;
                    font-weight: 700;
                    height: 90px;
                    line-height: 90px;
                    text-shadow: #fff 2px 0 0, #fff 0 2px 0, #fff -2px 0 0, #fff 0 -2px 0;
                    -webkit-text-shadow: #fff 2px 0 0,#fff 0 2px 0,#fff -2px 0 0,#fff 0 -2px 0;
                    -moz-text-shadow: #fff 2px 0 0,#fff 0 2px 0,#fff -2px 0 0,#fff 0 -2px 0;
                }
                .charts{
                    margin-top: 60px;
                    text-align: center;
                }
            }
        }
    }
</style>